module.exports = __webpack_public_path__ + "static/media/Cristian_Cadis_-_Frontend_Developer.b7a91f3a.pdf";